import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { doc, getDoc } from 'firebase/firestore';

const SETTINGS_DOC = 'audienceSettings';

/**
 * Interruptor de la funcionalidad de audiencias.
 *
 * Por defecto DESHABILITADO. Solo el booleano true lo habilita: cualquier otro
 * valor (ausente, false, o un truthy accidental como la cadena 'true') deja la
 * funcionalidad apagada, que es el estado seguro.
 */
export function resolveAudiencesEnabled(
  data: Record<string, unknown> | undefined,
): boolean {
  return data?.enabled === true;
}

export async function fetchAudiencesEnabled(): Promise<boolean> {
  try {
    const snap = await getDoc(doc(db, DOCUMENTS_DB.CONFIG, SETTINGS_DOC));
    return resolveAudiencesEnabled(snap.data());
  } catch (error) {
    console.error('Error leyendo audienceSettings:', error);
    // Ante un error de red, el estado seguro es deshabilitado.
    return false;
  }
}
